import { cn } from '~/@/lib/utils'

type AnimatedDossbotIconProps = {
  width?: number
  height?: number
  animate?: boolean
  className?: string
}

/**
 * Dossbot icon with eye blink + look-around animation.
 * When animate=true, eyes animate continuously.
 * When animate=false, eyes animate on hover only.
 *
 * Keyframes and animation classes are defined in ~/common/styles/dossbot-icon.css.
 */
export const AnimatedDossbotIcon = ({
  width = 28,
  height = 28,
  animate = true,
  className,
}: AnimatedDossbotIconProps) => {
  return (
    <svg
      className={cn('dossbot-icon', animate && 'dossbot-icon-animate', className)}
      fill="none"
      height={height}
      viewBox="0 0 32 32"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 5.5H22H16H7C5.34315 5.5 4 6.84315 4 8.5V16V21.25V22M28 10V10.75V16V23.5C28 25.1569 26.6569 26.5 25 26.5H16H10H8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <g className="dossbot-eyes">
        <rect
          className="dossbot-eye"
          fill="currentColor"
          height="6"
          rx="1"
          width="4.5"
          x="17.5"
          y="11.5"
        />
        <rect
          className="dossbot-eye"
          fill="currentColor"
          height="6"
          rx="1"
          width="4.5"
          x="10"
          y="11.5"
        />
      </g>
    </svg>
  )
}
